import React from 'react';
import { useOrganizationId } from '../../../../../../hooks/api/useOrganization';
import useOrganizationCareTeamMembers from '../../../../../../hooks/api/useOrganizationCareTeamMembers';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { CareTeamSideDrawerForm } from '../../../../../shared/CareTeamForm';
import { CareTeamMemberDetails } from '../../../../../../primary-record-types/apiTypes/medicalProfileService';

export type EditCareTeamMemberSideDrawerContentOwnProps = {
    onClose: (force: boolean) => void;
    careTeamMemberId: string;
};

export type EditCareTeamMemberSideDrawerContentProps = EditCareTeamMemberSideDrawerContentOwnProps;

const EditCareTeamMemberSideDrawerContent: React.FC<EditCareTeamMemberSideDrawerContentProps> = ({
    onClose,
    careTeamMemberId,
}) => {
    const organizationId = useOrganizationId();
    const {
        updateCareTeamMember,
        isUpdatingCareTeamMember,
        organizationCareTeamMember,
        isLoadingOrganizationCareTeamMember,
    } = useOrganizationCareTeamMembers({
        onUpdateCareTeamMember: () => onClose(true),
        organizationCareTeamMemberId: careTeamMemberId,
    });

    return (
        <AnimateLoadedContent
            isLoading={isLoadingOrganizationCareTeamMember || !organizationCareTeamMember || isUpdatingCareTeamMember}
        >
            {() => (
                <CareTeamSideDrawerForm
                    onSubmit={(updated) => {
                        updateCareTeamMember({
                            careTeamMemberId: careTeamMemberId,
                            update: updated,
                        });
                    }}
                    isSubmitting={isUpdatingCareTeamMember}
                    source={{
                        source: 'organization',
                        organizationId,
                    }}
                    careTeamMemberId={careTeamMemberId}
                    careTeamMemberDetails={(organizationCareTeamMember as CareTeamMemberDetails) || undefined}
                    shouldRecordAddCareTeamMember
                    onCancel={() => onClose(true)}
                />
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditCareTeamMemberSideDrawerContent);
